import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

const Day = ({ dayRaw, activeDay, clickHandler, dayFormat, dateFormat, dateFormatMobile }) => {
  const active = moment(dayRaw).isSame(moment(activeDay), 'day');

  const day = moment(dayRaw).format(dayFormat);
  const date = moment(dayRaw).format(dateFormat);
  const dateMobile = moment(dayRaw).format(dateFormatMobile);

  return (
    <button
      type="button"
      className={classNames(
        `mb-2 flex flex-grow flex-col items-center rounded-full border border-grey-2 px-4 py-2 text-center text-sm font-bold shadow-md`,
        active ? 'bg-green-900 text-grey-6' : 'bg-white text-primary hover:text-purple-6'
      )}
      onClick={() => {
        clickHandler(dayRaw);
      }}
    >
      <span className={classNames('block font-semibold capitalize', active ? 'text-white' : 'text-grey-600')}>
        {day}
      </span>
      <span
        className={classNames(
          'hidden whitespace-nowrap font-normal md:block',
          active ? 'text-orange-400' : 'text-grey-500'
        )}
      >
        {date}
      </span>
      <span
        className={classNames(
          'block min-w-[60px] whitespace-nowrap font-normal md:hidden',
          active ? 'text-orange-400' : 'text-grey-500'
        )}
      >
        {dateMobile}
      </span>
    </button>
  );
};

Day.propTypes = {
  // eslint-disable-next-line
  dayRaw: PropTypes.any.isRequired,
  // eslint-disable-next-line
  activeDay: PropTypes.any.isRequired,
  clickHandler: PropTypes.func.isRequired,
  dayFormat: PropTypes.string,
  dateFormat: PropTypes.string,
  dateFormatMobile: PropTypes.string,
};

Day.defaultProps = {
  dayFormat: 'ddd',
  dateFormat: 'D MMMM',
  dateFormatMobile: 'D MMM',
};

export default Day;
